<form class="app-grid" #form="ngForm">
    <div class="stripe-form-field required columns-12">
        <label>{{ 'settings.payment-information-form.cardNumberLabel' | appTranslate }}</label>
        <div class="stripeField" id="cardNumber"></div>
        <span class="error">{{ cardNumberError }}</span>
    </div>

    <div class="stripe-form-field required columns-6">
        <label>{{ 'settings.payment-information-form.cardExpiryLabel' | appTranslate }}</label>
        <div class="stripeField" id="cardExpiry"></div>
        <span class="error">{{ cardExpiryError }}</span>
    </div>

    <div class="stripe-form-field required columns-6">
        <label>{{ 'settings.payment-information-form.cardCvcLabel' | appTranslate }}</label>
        <div class="stripeField" id="cardCvc"></div>
        <span class="error">{{ cardCvcError }}</span>
    </div>

    <mat-form-field class="columns-12">
        <mat-label>{{ 'settings.payment-information-form.nameOnCardLabel' | appTranslate }}</mat-label>
        <input
            matInput
            type="text"
            required
            #nameField="ngModel"
            name="name"
            [(ngModel)]="name"
            placeholder="{{ 'settings.payment-information-form.nameOnCardPlaceholder' | appTranslate }}"
        />
        <mat-error *ngIf="nameField.invalid">{{ nameField.errors | formErrors }}</mat-error>
    </mat-form-field>

    <mat-form-field class="columns-12">
        <mat-label>{{ 'settings.payment-information-form.billingAddressLabel' | appTranslate }}</mat-label>
        <input
            matInput
            type="text"
            required
            #addressLine1Field="ngModel"
            name="addressLine1"
            [(ngModel)]="addressLine1"
            placeholder="{{ 'settings.payment-information-form.billingAddressPlaceholder' | appTranslate }}"
        />
        <mat-error *ngIf="addressLine1Field.invalid">{{ addressLine1Field.errors | formErrors }}</mat-error>
    </mat-form-field>

    <mat-form-field>
        <mat-label>{{ 'settings.payment-information-form.suiteUnitLabel' | appTranslate }}</mat-label>
        <input
            matInput
            type="text"
            #addressLine2Field="ngModel"
            name="addressLine2"
            [(ngModel)]="addressLine2"
            placeholder="{{ 'settings.payment-information-form.suiteUnitPlaceholder' | appTranslate }}"
        />

        <mat-error *ngIf="addressLine2Field.invalid">{{ addressLine2Field.errors | formErrors }}</mat-error>
    </mat-form-field>

    <mat-form-field>
        <mat-label>{{ 'settings.payment-information-form.cityLabel' | appTranslate }}</mat-label>
        <input
            matInput
            type="text"
            required
            #cityField="ngModel"
            name="city"
            [(ngModel)]="city"
            placeholder="{{ 'settings.payment-information-form.cityPlaceholder' | appTranslate }}"
        />
        <mat-error *ngIf="cityField.invalid">{{ cityField.errors | formErrors }}</mat-error>
    </mat-form-field>

    <mat-form-field>
        <mat-label>{{ 'settings.payment-information-form.countryLabel' | appTranslate }}</mat-label>
        <ui-country-autocomplete
            required
            name="country"
            #countryInput="ngModel"
            [(ngModel)]="country"
        ></ui-country-autocomplete>
        <mat-error *ngIf="countryInput.invalid">{{ countryInput.errors | formErrors }}</mat-error>
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{ 'settings.payment-information-form.stateProvinceLabel' | appTranslate }}</mat-label>
        <ui-state-autocomplete
            required
            name="province"
            #provinceInput="ngModel"
            [country]="country"
            [(ngModel)]="province"
        ></ui-state-autocomplete>
        <mat-error *ngIf="provinceInput.invalid">{{ provinceInput.errors | formErrors }}</mat-error>
    </mat-form-field>

    <ng-container *ngIf="country === 'Canada'; else notCanada">
        <mat-form-field>
            <mat-label>{{ 'settings.payment-information-form.postalCodeLabel' | appTranslate }}</mat-label>
            <input
                matInput
                type="text"
                required
                name="postalCode"
                #postalCodeField="ngModel"
                [(ngModel)]="postalCode"
                placeholder="{{ 'settings.payment-information-form.postalCodePlaceholder' | appTranslate }}"
            />
            <mat-error *ngIf="postalCodeField.invalid">{{ postalCodeField.errors | formErrors }}</mat-error>
        </mat-form-field>
    </ng-container>

    <ng-template #notCanada>
        <mat-form-field>
            <mat-label>{{ 'settings.payment-information-form.zipPostalCodeLabel' | appTranslate }}</mat-label>
            <input
                matInput
                type="text"
                required
                name="postalCode"
                #postalCodeField="ngModel"
                [(ngModel)]="postalCode"
                placeholder="{{ 'settings.payment-information-form.zipPostalCodePlaceholder' | appTranslate }}"
            />
            <mat-error *ngIf="postalCodeField.invalid">{{ postalCodeField.errors | formErrors }}</mat-error>
        </mat-form-field>
    </ng-template>
</form>
